import { RequirementCategoryType } from '@/backend/access/requirementEvidenceCategory/types';
import { I18n } from '@/i18n/I18n';
import { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

interface EvidenceCategoryModalProps {
  onSubmit: (data: { name: string; description: string }) => Promise<void>;
  label: string;
  currentName?: string;
  currentDescription?: string | null;
  onHide: () => void;
  type: RequirementCategoryType;
}

export function EvidenceCategoryModal({
  onSubmit,
  label,
  currentName,
  currentDescription,
  onHide,
  type,
}: EvidenceCategoryModalProps) {
  const [name, setName] = useState(currentName ?? '');
  const [nameError, setNameError] = useState('');
  const [description, setDescription] = useState(currentDescription ?? '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    setName('');
    setDescription('');
    onHide();
  };

  const handleSave = async () => {
    if (!name.trim()) {
      setNameError(I18n.get('requiredFieldError', { field: I18n.get('name') }));
      return;
    }
    setIsSubmitting(true);
    try {
      await onSubmit({
        name: name.trim(),
        description: description.trim(),
      });
      handleClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show onHide={handleClose}>
      <Modal.Body>
        <Modal.Title className='pb-3'>{label}</Modal.Title>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="form-label-neutral">{I18n.get('categoryName')}</Form.Label>
            <Form.Control
              className="form-control-neutral"
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setNameError('');
              }}
              isInvalid={!!nameError}
              aria-label={I18n.get('categoryName')}
            />
            <Form.Control.Feedback type="invalid"> {nameError} </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="form-label-neutral">{I18n.get('description')} ({I18n.get('optional')})</Form.Label>
            <Form.Control
              className="form-control-neutral"
              placeholder={I18n.get('categoryDescriptionPlaceholder', { type: I18n.get(type).toLowerCase() })}
              as="textarea"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              aria-label={I18n.get('description')}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-blue-light fusa-btn-medium" onClick={handleClose} disabled={isSubmitting}>
          {I18n.get('cancel')}
        </Button>
        <Button className="fusa-btn-medium fusa-btn-primary" onClick={() => void handleSave()} disabled={isSubmitting}>
          {isSubmitting ? I18n.get('saving') : I18n.get('save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
